<template>
  <main>
    <b-modal centered @hidden="handleCloseModal" scrollable v-model="show">
      <template #modal-header>
        <div class="example">
          <h2>{{ titleModal }}</h2>
          <p class="error-message">{{ errorMessage }}</p>
        </div>
      </template>
      <b-row class="inputs-container align-items-center">
        <b-col cols="12" class="input-date m-0 mb-4">
          <label class="small-icon label-date mr-3">Predefined goal (optional)</label>
          <b-form-select v-model="selectedCriterionName" size="sm" :options="categories">
            <template #first>
              <b-form-select-option class="text-normal" :value="null"
                >-Select goal-</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="12" sm="7" class="input-upper d-flex">
          <textarea
            id="name-input"
            cols="30"
            rows="1"
            type="textarea"
            v-model="criterialName"
            :disabled="selectedCriterionName"
          ></textarea>
          <label class="small-icon"
            >Goal name
            <span class="text-required" v-if="!validForm.goalName">required*</span></label
          >
          <emojis
            :customClass="'mt-auto'"
            :input="criterialName"
            :onClick="(value) => addEmoji(value)"
            :class="{ 'user-select-none': selectedCriterionName }"
            :disabled="!!selectedCriterionName"
          />
        </b-col>
        <b-col cols="12" sm="5" class="p-0">
          <b-link
            @click="$refs.imageModal.openModal()"
            class="text-uppercase small align-items-center b-link"
            :style="image.selected ? 'color: green !important' : ''"
          >
            <span class="material-icons align-middle">add_photo_alternate</span>
            {{ image.selected ? 'Change image' : 'Add image' }}
          </b-link>
        </b-col>
        <b-col cols="12" class="my-3 wrapper-category">
          <label class="small-icon label-date mr-3">
            Category
          </label>
          <b-form-group class="m-0">
            <b-form-radio-group
              class="radio-sub-cat"
              name="radio-parent-goal"
              v-model="categoriesSelected"
            >
              <b-form-radio
                v-for="item in getCriterionCategories"
                :key="'criterion-categories-' + item.id"
                :value="item.id"
                class="m-auto h-100 p-0 overflow-hidden"
              >
                <span class="material-icons small" :style="`color:${item.color};`">lens</span>
                {{ item.name }}
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="12" class="input-upper">
          <b-img
            fluid
            :src="require(`@/assets/icons/icon-money-star.png`)"
            class="icon-star-small h-auto input-star"
          ></b-img>
          <b-input
            id="coin-input"
            type="number"
            v-model="countStars"
            class="pl-4"
            min="0"
            required
          ></b-input>
          <label class="small-icon plx-3">
            How many stars?
            <span class="text-required" v-if="!validForm.countStars">required*</span>
          </label>
        </b-col>
        <b-col cols="12" class="input-date">
          <label class="small-icon label-date mr-3"
            >Time of day
            <span class="text-required" v-if="!validForm.timeOfDay">required*</span></label
          >
          <div v-if="loading">
            <div
              class="three w-100 d-flex align-items-center"
              :class="'bg-light'"
              style="height: 25vh;"
            >
              <div class="loader" id="loader-1"></div>
            </div>
          </div>
          <div v-else>
            <div
              v-for="(item, idx) in dayChoices"
              :key="'criterialTimeDayChoices-' + idx"
              class="mb-2"
            >
              <div>
                <b-form-checkbox v-model="item.value" size="lg" class=" ml-3">
                  <span class="small">
                    {{ item.text }}
                  </span>
                </b-form-checkbox>
              </div>
              <b-row class="mx-3 mb-3 bg-light py-2" v-if="item.value">
                <b-col cols="12" lg="12" class="category-tags">
                  <label class="small-icon label-date mr-3">
                    Frequency
                  </label>
                  <b-form-group class="m-0">
                    <b-form-radio-group
                      v-for="itm in getCriterionTimeFrequencyChoices"
                      :key="idx + '-frequency-' + itm.value"
                      v-model="item.frequency.id"
                      :name="idx + 'c' + 'radio-sub-cat'"
                      class="radio-sub-cat"
                    >
                      <b-form-radio
                        :value="itm.value"
                        :id="idx + 'c' + itm.value.toString()"
                        class="m-auto h-100 p-0"
                      >
                        {{ itm.text }}
                        <span
                          v-if="itm.value === 'bonus_date' || itm.value === 'bonus_one_time'"
                          class="material-icons text-warning align-middle"
                          >military_tech</span
                        >
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                  <div v-if="item.frequency.id === 'bonus_date'">
                    <label class="small-icon label-date mr-3">
                      Day
                    </label>
                    <b-form-datepicker
                      :state="!!item.frequency.date"
                      :date-disabled-fn="disableDaysToCurrentDate"
                      locale="en"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit',
                        weekday: 'short',
                      }"
                      id="parent-goal-modal-datepicker"
                      v-model="item.frequency.date"
                      class="mb-2"
                      :class="!!item.frequency.date ? 'custom-text-success' : 'custom-text-danger'"
                    ></b-form-datepicker>
                  </div>
                  <div v-if="item.frequency.id === 'weekly'">
                    <label class="small-icon label-date mr-3">Day</label>
                    <div class="d-flex flex-wrap">
                      <b-form-radio-group
                        v-model="item.frequency.day"
                        :name="idx + 'c' + 'radio-day'"
                        class="radio-sub-cat d-fex"
                      >
                        <b-form-radio
                          v-for="dayItem in getCriterionDaysOfWeek"
                          :key="idx + '-days-' + dayItem.value"
                          :value="dayItem.value"
                          :id="idx + 'c' + dayItem.value.toString()"
                          class="p-0 mr-1"
                        >
                          {{ dayItem.text }}
                        </b-form-radio>
                      </b-form-radio-group>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- Button save criterion -->
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="warning" block @click="handleSaveController()">
            Save
          </b-button>
          <b-button v-if="isValidForm" variant="warning" block @click="handleCancel">
            Cancel
          </b-button>
        </div>
      </template>
      <!-- /Button save criterion -->
    </b-modal>
    <!-- Modal Image -->
    <challenge-add-image-modal ref="imageModal" @onChangeSelectedImage="handleSelectedImage" />
  </main>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { sentenceCase } from '@/utils';
import mixinNotificationToast from '@/mixins/notificationToast.mixin.js';

import Emojis from '@/components/general/emojis/emojis.vue';
import challengeAddImageModal from './ChallengeAddImageModal.vue';

export default {
  mixins: [mixinNotificationToast],
  components: { Emojis, challengeAddImageModal },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
    child: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      show: false,
      image: {
        selected: false,
        imageId: null,
      },
      countStars: 0,
      criterialName: '',
      categoriesSelected: null,
      selectedCriterionName: null,
      dayChoices: [],
      loading: true,
      daySelectedCopy: null,
      criteriaId: null,
      errorMessage: null,
    };
  },
  async mounted() {
    try {
      this.loading = true;
      this.dayChoices = this.inicializateDayChoices(this.getCriterionTimeDayChoices);
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
      if (this.daySelectedCopy != null) {
        this.selectDayTime({
          timeDay: this.daySelectedCopy,
          frequency: this.frequencySelectedCopy,
        });
      }
    }
  },
  watch: {
    selectedCriterionName() {
      this.criterialName = '';
    },
  },
  computed: {
    ...mapGetters('user', ['getUserId']),
    ...mapGetters('challenge', [
      'getPredefinedCriterion',
      'getCriterionCategories',
      'getCriterionTimeDayChoices',
      'getCriterionTimeFrequencyChoices',
      'getCriterionDaysOfWeek',
      'getCriterionImages',
    ]),
    categories() {
      return this.getPredefinedCriterion.map((criterion) => ({
        value: criterion.id,
        text: sentenceCase(criterion.name),
      }));
    },
    validForm() {
      const isTimeOfDaySelected = this.dayChoices.some((time) => time.value);
      return {
        timeOfDay: isTimeOfDaySelected,
        countStars: Number(this.countStars) > 0,
        goalName: this.criterialName !== '' || this.selectedCriterionName !== null,
      };
    },
    isValidForm() {
      const { timeOfDay, countStars, goalName } = this.validForm;
      return timeOfDay && countStars && goalName;
    },

    titleModal() {
      return this.isNew ? 'New Goal' : 'Edit Goal';
    },
  },
  methods: {
    ...mapActions('challenge', ['CreateNewCriterion', 'UpdateNewCriterion']),
    inicializateDayChoices(criterionDayChoices) {
      return criterionDayChoices.map(({ value, text }) => ({
        id: parseInt(value),
        text: text !== 'None' ? text : 'Anytime',
        value: false,
        frequency: { id: 'daily', date: null, day: null },
        stars: null,
      }));
    },
    selectDayTime({ timeDay, frequency }) {
      this.dayChoices.forEach((element) => {
        if (element.id == timeDay) {
          element.value = true;
          element.frequency = frequency;
        }
      });
    },
    disableDaysToCurrentDate(_, date) {
      const externalDate = new Date(date);
      const currentDate = new Date();
      return (
        externalDate.getTime() < currentDate.getTime() &&
        externalDate.getDate() !== currentDate.getDate()
      );
    },
    openModal(data = null) {
      this.show = true;
      if (data != null) {
        let { challenge, timeDay } = data;
        this.criteriaId = challenge.challenge_criterion;
        this.criterialName = challenge.text;
        this.countStars = challenge.coin_value;
        if (challenge.category) {
          this.categoriesSelected = challenge.category.id;
        }
        const frequency = {
          id: challenge.challenge_frequency,
          day: challenge.challenge_day,
          date: challenge.challenge_date,
        };
        if (!this.loading) {
          this.selectDayTime({
            timeDay,
            frequency: frequency,
          });
        } else {
          this.daySelectedCopy = timeDay;
          this.frequencySelectedCopy = frequency;
        }
        if (challenge.image) {
          this.image.selected = true;
          let selectedImage = this.getCriterionImages.find(
            (image) => image.image == challenge.image,
          );
          if (selectedImage != null) {
            this.image.imageId = selectedImage.id;
          }
        }
      }
    },
    closeModal() {
      this.show = false;
    },
    getCategoryText(id) {
      const category = this.getCriterionCategories.find((c) => c.id == id);
      return category ? `(${category.text})` : '';
    },
    handleSelectedImage({ selected, imageId }) {
      this.image = {
        selected,
        imageId,
      };
    },
    addEmoji(emoji) {
      this.criterialName += emoji;
    },
    timeDayAdapter(timeDayChoices) {
      return timeDayChoices
        .filter((date) => date.value)
        .map((data) => {
          const response = {
            time_day_choice: data.id,
            starsValue: this.countStars,
            frequency: data.frequency.id,
          };
          if (response.frequency === 'bonus_date') response['date'] = data.frequency.date;
          if (response.frequency === 'weekly') response['day'] = data.frequency.day;
          return response;
        });
    },
    dataAdapterToSend() {
      const date = this.$route.query.date;
      let text = this.criterialName;

      if (this.selectedCriterionName) {
        const criterialSelected = this.categories.find(
          (category) => category.value === this.selectedCriterionName,
        );
        text = criterialSelected.text || '';
      }

      const dataToRequest = {
        child: this.child,
        parent: this.getUserId,
        text,
        time_day: this.timeDayAdapter(this.dayChoices),
        date,
        id: this.criteriaId,
      };

      if (this.image.selected) {
        dataToRequest['image'] = this.image.imageId;
      }

      if (this.categoriesSelected) {
        dataToRequest['category'] = this.categoriesSelected;
      }

      return dataToRequest;
    },
    resetValues() {
      this.image = {
        selected: false,
        imageId: null,
      };
      this.countStars = 0;
      this.criterialName = '';
      this.categoriesSelected = null;
      this.selectedCriterionName = null;
      this.dayChoices = this.inicializateDayChoices(this.getCriterionTimeDayChoices);
      this.errorMessage = null;
    },

    handleShowErrors() {
      this.errorMessage =
        'Goal won´t save?  Scroll down and complete the required * fields: goal name, how many stars and time of day';
    },

    handleCancel() {
      this.closeModal();
      this.resetValues();
    },

    async handleSave() {
      try {
        const data = this.dataAdapterToSend();
        if (this.criteriaId != null) {
          this.UpdateNewCriterion(data);
        } else {
          await this.CreateNewCriterion(data);
        }
        this.notificationToast({
          message: 'The goal has been created',
          variant: 'success',
          title: 'Create a Goal',
        });
      } catch (error) {
        console.error(error);
        this.notificationToast({ message: error, variant: 'danger', title: 'Create a Goal' });
      } finally {
        this.closeModal();
      }
    },

    handleSaveController() {
      if (this.isValidForm) return this.handleSave();
      this.handleShowErrors();
    },

    handleCloseModal() {
      this.resetValues();
    },
  },
};
</script>
<style lang="scss">
.error-message {
  color: red;
  font-size: 0.7rem;
}

@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .wrapper-category {
      .form-group {
        .bv-no-focus-ring {
          display: block !important;
          flex-wrap: nowrap !important;
        }
      }
    }
  }
}
.custom-select {
  text-transform: initial;
  option {
    text-transform: none;
  }
}

.category-tags .custom-radio .custom-control-label::before {
  display: none;
}

.category-tags .custom-control-label::after {
  display: none;
}

.wrapper-category {
  .form-group {
    .bv-no-focus-ring {
      display: block !important;
    }
  }
}

.text-required {
  color: red;
  font-size: 10px;
  text-transform: capitalize;
}

.radio-sub-cat {
  input[type='radio'],
  input[type='checkbox'] {
    & + label {
      background-color: #e9ecef;
      padding: 5px 12px;
      border-radius: 50px;
      margin: 5px;
      cursor: pointer;

      i {
        display: none;
      }
    }
  }
  input[type='radio']:checked,
  input[type='checkbox']:checked {
    & + label {
      background-color: var(--aside003);
      color: #fff;
      i {
        font-size: 32px;
        display: block;
      }
    }
  }
}
</style>
